import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { LoggingService } from "../../../../../../../services/logging.service";

@Injectable({
  providedIn: "root",
})
export class SparkHistoryService {
  private _isOverlayVisible = new BehaviorSubject<boolean>(false);
  private _currentSparkId = new BehaviorSubject<number | null>(null);

  public isOverlayVisible$ = this._isOverlayVisible.asObservable();
  public currentSparkId$ = this._currentSparkId.asObservable();

  constructor(private loggingService: LoggingService) {}

  /**
   * Opens the spark history overlay for a specific spark ID
   * @param sparkId The ID of the spark to show history for
   */
  openSparkHistory(sparkId: number): void {
    this._currentSparkId.next(sparkId);
    this._isOverlayVisible.next(true);
  }

  /**
   * Closes the spark history overlay
   */
  closeSparkHistory(): void {
    this._isOverlayVisible.next(false);
    this._currentSparkId.next(null);
  }

  /**
   * Gets spark logs for the specified spark ID
   * @param sparkId The spark ID to get logs for
   * @param searchTerm Optional search term to filter logs
   * @returns Promise with log data
   */
  async getSparkLogs(sparkId: number, searchTerm?: string): Promise<any> {
    const logRequest = {
      LogRequest: {
        LogItemID: sparkId,
        LogType: "spark",
        SearchTerm: searchTerm || null,
      },
    };

    return await this.loggingService.getLogs(logRequest);
  }
}
